import React from "react";
import useFetch from "../../../../hooks/useFetch";
import { subscriptionListFont } from "../../../../services/subscriptionService";
import dayjs from "dayjs";

const CurrentSubscription = () => {
  const { data: subscriptionData } = useFetch({
    dependencies: ["dashboardSubscription"],
    fetchFunction: async () => {
      const res = await subscriptionListFont({ status: "active" });
      if (res?.docs?.status === 200) {
        return res?.docs?.data || [];
      }
      return [];
    },
  });

  const statusHexColorMap = {
    active: "#06D6A0",
    Expiring: "#4f46e5",
    Expired: "#fb923c",
    Cancelled: "#ef427c",
    inactive: "#ef427c",
  };

  const subscriptiondata = subscriptionData?.[0];

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            Active Plan
          </div>
        </div>
        <div
          className="relative space-y-4"
          style={{
            "--statusColor":
              statusHexColorMap[subscriptiondata?.paymentGateway?.status],
          }}
        >
          <div className="flex gap-4">
            <div className="flex-shrink-0">
              <div className="flex-shrink-0 text-2xl 2xl:text-4xl w-12 2xl:w-16 aspect-square flex items-center justify-center rounded-lg shadow-lg shadow-md-green/20 transition-all duration-300 text-white bg-md-green">
                <i className="fa-fw fa-light fa-tickets-perforated"></i>
              </div>
            </div>
            <div className="space-y-2 flex-shrink flex-grow-0">
              <h2 className="text-base 2xl:text-lg 3xl:text-xl font-semibold text-md-dark !leading-none">
                {subscriptiondata?.planData?.name}
              </h2>
              {subscriptiondata?.planData?.features?.length > 0 && (
                <div className="text-xs 2xl:text-sm text-slate-500">
                  <ul className="3xl:columns-2 list-disc list-outside pl-4">
                    {subscriptiondata?.planData?.features?.map(
                      (item, index) => (
                        <li key={index}>{item?.name}</li>
                      )
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="flex 2xl:items-center justify-between pt-2 border-t border-md-pink-light-1 flex-wrap gap-1 flex-col-reverse 2xl:flex-row">
            <div className="flex-shrink flex-grow">
              {/* <div className="text-xs 2xl:text-sm text-slate-500">
                <span className="text-md-dark font-semibold">Validity:</span>{" "}
                {dayjs(subscriptiondata?.startDate).format("DD MMMM, YYYY") +
                  " - " +
                  dayjs(subscriptiondata?.endDate).format("DD MMMM, YYYY")}
              </div> */}
            </div>
            <div className="flex-shrink-0">
              <div
                className="relative text-[10px] inline-flex items-center gap-x-1 leading-none uppercase py-1 px-1 rounded-full tracking-widest font-semibold"
                style={{ color: "var(--statusColor)" }}
              >
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl opacity-10"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl border opacity-10"
                  style={{ borderColor: "var(--statusColor)" }}
                />
                <div
                  className="w-3 h-3 rounded-full animate-pulse"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <span className="px-1">
                  {subscriptiondata?.paymentGateway?.status}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrentSubscription;
